module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2020-06-03 at 19.10.29.974ac200.jpeg";